import { NgClass, NgFor, NgIf, NgStyle } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, inject, DestroyRef, effect, ChangeDetectorRef } from '@angular/core';
import { RelationshipService } from 'src/app/shared/services/relationship/relationship.service';
import * as _ from 'lodash'
import * as moment from 'moment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { LtmsEventHandlerService } from 'src/app/shared/services/ltms-event-handler/ltms-event-handler.service';
import { FeedDetailPanelComponent } from 'src/app/shared/components/feed-detail-panel/feed-detail-panel.component';
import { DomSanitizer } from '@angular/platform-browser';
import { LtmsLoaderComponent } from 'src/app/shared/components/ltms-loader/ltms-loader.component';
import { ScoreDropdownMenuComponent } from 'src/app/shared/components/score/score-dropdown-menu/score-dropdown-menu.component';
import { LitmusChartBetaComponent } from 'src/app/shared/components/litmus-chart-beta/litmus-chart-beta/litmus-chart-beta.component';
@Component({
  selector: 'app-customer-journey-view',
  standalone: true,
  templateUrl: './customer-journey-view.component.html',
  styleUrls: ['./customer-journey-view.component.scss'],
  imports: [NgClass, NgFor, NgIf, NgStyle, FeedDetailPanelComponent, LtmsLoaderComponent, ScoreDropdownMenuComponent, LitmusChartBetaComponent]
})

export class CustomerJourneyViewComponent implements OnInit, OnChanges {
  @Output() closePanel: any = new EventEmitter<any>();
  @Input() customerDetail: any = {};

  tabs = [
    { key: 'overview', name: 'Overview' },
    { key: 'timeline', name: 'Timeline' }
  ];
  activeTab = this.tabs[0];
  viewTypeDropdown: any = {
    config: {
      width: '300px',
      isDisabled: false,
      tab: 'journeyViewtype'
    },
    selectedOption: '',
    options: []
  };

  // Loading states
  isDataLoaded: boolean = false;
  isFeedsLoading: boolean = true;
  isLineChartDataLoading: boolean = true;
  isChartDataLoading: boolean = true;
  isTrendSummaryLoading: boolean = true;

  // No data flags
  showNoCustomerData: boolean = false;
  showNoChartData: boolean = false;
  showNoTrendData: boolean = false;
 

  barChartConfig: any = {
    chartType: 'bar',
    yText: 'Responses',
    minRotation: 0,
    maxRotation: 0,
    stacked: false,
    useCustomConfig: true,
    minBarWidth: 30,
    stepSize: 20,
    min: -100,
    max: 100,
    data: {
      labels: [],
      datasets: []
    }
  }

  lineChartConfig: any = {
    chartType: 'line',
    yText: 'Rating',
    minRotation: 0,
    maxRotation: 0,
    stacked: false,
    useCustomConfig: true,
    minBarWidth: 20,
    min: 0,
    max: 10,
    data: {
      labels: [],
      datasets: []
    }
  }

  /** Dummy data for the line chart input */
  lineChartData: any = {
    labels: [],
    data: []
  };

  readonly lineChartPlugins = {
    lineColor: '#6C63FF',
    gradientStartColor: '#E0E7FF',
    gradientEndColor: '#FFFFFF',
    borderWidth: 3,
    pointBorderWidth: 2,
    pointRadius: 5,
    pointBorderColor: '#6C63FF',
    min: 0,
    max: 10,
  };


  lifetimeResponses: any = []
  destroyRef = inject(DestroyRef)
  accountId: any = null;

  brandDetailsMap: any = {};
  lineChartDatastore: any = {
    journeyNames: [],
    data: {}
  }
  npsType: string = ''
  journeyConfig: any = {};
  isTabLoading: boolean = false
  activeTableFilter: any = null;
  lifeTimeResponsesCache: any = [];
  constructor(
    private _relationshipService: RelationshipService,
    private _stateService: AppStateService,
    private cdr: ChangeDetectorRef,
    private _ltmsEvents: LtmsEventHandlerService,
    private sanitizer: DomSanitizer
  ) {
    effect(() => {
      let accountDetails: any = this._stateService.accountDetails();
      let brandListDetails: any = this._stateService.brandListDetails();
      if (_.isEmpty(brandListDetails) && !_.isEmpty(Helpers?.brandListDetail)) {
        brandListDetails = Helpers.brandListDetail;
      }
      if (brandListDetails && !_.isEmpty(brandListDetails)) {
        this.getBrandDetailsMap(brandListDetails);
      }
      if (accountDetails && accountDetails._id) {
        this.accountId = accountDetails._id;
        if (this.accountId && this.journeyConfig && !_.isEmpty(this.journeyConfig)) {
          this.getUserFeeds();
          this.getTrendSummary();
        }

      }
    })
    effect(() => {
      let journeyConfig: any = this._relationshipService.journeyConfig();
      if (journeyConfig && !_.isEmpty(journeyConfig)) {
        this.journeyConfig = Helpers.deepClone(journeyConfig)
        if (this.accountId && this.journeyConfig && !_.isEmpty(this.journeyConfig)) {
          this.selectedProfileType = this._relationshipService.unique_field_id.replace('tag_private_', '');
          this.getUserFeeds();
          this.getTrendSummary();
        }
      }
    })
  }

  ngOnInit(): void {
    // Initialize sorted data
    this.applySorting();
    if (this.customerDetail?.nps) {
      if (this.customerDetail.nps == 'NA') {
        this.npsType = 'unavailable'
      } else {
        const nps = parseInt(this.customerDetail.nps)
        if (nps < 0) {
          this.npsType = 'negative'
        } else if (nps > 0 && nps <= 30) {
          this.npsType = 'neutral'
        } else if (nps > 30) {
          this.npsType = 'positive'
        }

      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customerDetail'] && changes['customerDetail'].currentValue) {
      // Reset chart data when customer detail changes
      this.resetChartData();
      // Refresh data if accountId is available
      if (this.accountId) {
        this.getUserFeeds();
        this.getTrendSummary();
      }
    }
    // Apply sorting when data changes
    if (this.lifetimeResponses.length > 0) {
      this.applySorting();
    }
  }

  getBrandDetailsMap(brandListDetails) {
    if (brandListDetails && !_.isEmpty(brandListDetails)) {
      _.each(brandListDetails, (brand: any) => {
        this.brandDetailsMap[brand._id] = brand;
      });
    }
  }

  changeTab(tab: any) {
    this.activeTab = tab;
    // if(this.activeTab && this.activeTab.key == 'timeline' && this.lifetimeResponses.length > 0 ){
    //   this.sortDirection = 'desc';
    //   this.sortColumn = 'formated_created_date';
    //   this.applySorting();
    // }
  }
  closeQuestionModal() {
    this.closePanel.emit()
  }
  selectedProfileType: any = null
  showProfileDetails(type: string) {
    if (this.selectedProfileType === type) {
      this.selectedProfileType = null
    } else {
      this.selectedProfileType = type
    }
  }

  trendSummary: any = [];
  getTrendSummary() {
    this.isChartDataLoading = true;
    let params: any = this.getQueryParams();
    this._relationshipService.getRelationshipTrendSummary(params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res: any) => {
      if (_.get(res, 'data.code') == 0 && _.has(res, 'data.summary') && !_.isEmpty(res.data.summary)) {
        this.prepareTrendSummary(res.data.config, res.data.summary);
      } else {
        this.barChartConfig.data.labels = [];
        this.barChartConfig.data.datasets = [];
        this.resetChartData();
      }
      this.isChartDataLoading = false;
      this.cdr.detectChanges();
    }, (error) => {
      console.error('Error fetching trend summary:', error);
      this.barChartConfig.data.labels = [];
      this.barChartConfig.data.datasets = [];
      this.resetChartData();
      this.isChartDataLoading = false;
      this.cdr.detectChanges();
    })
  }

  resetChartData() {
    this.barChartConfig.data.labels = [];
    this.barChartConfig.data.datasets = [];
    this.lineChartData = {
      labels: [],
      data: []
    };
    this.chartData = {
      dates: [],
      barChartDataSets: [],
      linchartData: [],
      journeyNames: []
    };
    this.activeJourney = null;
  }

  activeJourney: any = null;
  chartData: any = {
    dates: [],
    barChartDataSets: []
  };
  prepareTrendSummary(config: any, trendSummary: any) {
    let chartData: any = {
      dates: [],
      barChartDataSets: {},
    };
    const journeyList = _.get(config, 'configs', []);
    if (trendSummary && !_.isEmpty(trendSummary)) {
      let sortedDates = Object.keys(trendSummary).sort();


      const mappedTrendSummary = this.getMappedTrendSummary(trendSummary);
      _.each(sortedDates, (date: string) => {
        let formated_date = moment(date).format("MMM 'YY");
        chartData.dates.push(formated_date)
        const mappedObj = mappedTrendSummary[date];
        _.each(journeyList, (journey: any, index: number) => {
          const key = journey.id || journey.name;
          if(!chartData.barChartDataSets[key]) {
            chartData.barChartDataSets[key] = {
              label: journey.name,
              data: [],
              backgroundColor: this.getColorForIndex(index),
            };
          }
          let nps: any = null;
          if(mappedObj[key] && mappedObj[key].total_responses > 0) {
            nps = this.getNPS(mappedObj[key].total_responses, mappedObj[key].promoter, mappedObj[key].detractor);
            if (nps == 'NA') {
              nps = null;
            } else {
              nps = Number(nps);
            }
          }
          chartData.barChartDataSets[key].data.push(nps)
        })
      })
    }

    if (chartData.dates && chartData.dates.length > 0) {
      this.updateBarChartData(chartData.dates, chartData.barChartDataSets,journeyList);
    } else {
      this.updateBarChartData([], {},journeyList);
    }
    this.cdr.detectChanges();
  }

  getMappedTrendSummary(trendSummary: any) {
    let mappedTrendSummary: any = {};
    if (trendSummary && !_.isEmpty(trendSummary)) {
      _.each(trendSummary, (obj: any, date: string) => {
        if (!mappedTrendSummary[date]) {
          mappedTrendSummary[date] = {};
        }
        _.each(obj, (journeySummary: any, index: number) => {
          const key = journeySummary.journey_id || journeySummary.journey_name;
          if (!mappedTrendSummary[date][key]) {
            mappedTrendSummary[date][key] = journeySummary;
          }
        })
      })
    }
    return mappedTrendSummary;
  }

  getColorForIndex(index: number): string {
    const colors = [
      '#65C7FF',
      '#A066FF',
      '#00D2BE',
      '#FF6B81',
      '#FF9E45',
      '#9013FE',
      '#6C8091',
      '#9ECAD6',
      '#748DAE',
      '#EC7FA9',
      '#BE5985'
    ];
    return (!colors[index]) ? (this.generateRandomHexColor()) : (colors[index % colors.length]);
  }

  generateRandomHexColor() {
    // Generate a random number between 0 and 16777215 (0xFFFFFF)
    const randomNumber = Math.floor(Math.random() * 0xFFFFFF);

    // Convert the number to a hexadecimal string
    let hexColor = randomNumber.toString(16);

    // Pad the hexadecimal string with leading zeros if necessary
    // to ensure it's always 6 digits long
    while (hexColor.length < 6) {
      hexColor = "0" + hexColor;
    }

    // Prepend '#' to form a valid hex color code
    return ("#" + hexColor).toUpperCase();
  }

  changeJourney(event: any) {
    this.activeJourney = event?.name;
    this.isLineChartDataLoading = true;
    if (this.lineChartDatastore.data && this.lineChartDatastore.data[this.activeJourney]) {
      this.updateLineChartData(this.lineChartDatastore.data[this.activeJourney]);
    } else {
      this.updateLineChartData(null);
    }
    this.cdr.detectChanges();
  }

  updateBarChartData(dates: any, barChartDataSets: any, journeyList: any) {
    // Force new object reference to trigger change detection

    let datasets: any = [];
    _.each(journeyList, (journey: any) => {
      const key = journey.id || journey.name;
      if (barChartDataSets[key] && barChartDataSets[key]?.data?.length > 0) {
        datasets.push(barChartDataSets[key])
      }
    })
    this.barChartConfig.data.labels = [...dates];
    this.barChartConfig.data.datasets = [...datasets];
    this.cdr.detectChanges();
  }

  updateLineChartData(linchartData: any) {
    // Force new object reference to trigger change detection
    if (linchartData && linchartData.labels && linchartData.data) {
      this.lineChartData = {
        labels: [...linchartData.labels],
        data: [...linchartData.data]
      };
      this.lineChartConfig.data.labels = [...linchartData.labels];

      this.lineChartConfig.data.datasets = [{
        data: [...linchartData.data],
        borderColor: '#6C63FF',
        borderWidth: 3,
        pointBorderWidth: 0,
        label: 'Response Date',
        pointRadius: 0,
        pointBorderColor: '#6C63FF',
        pointBackgroundColor: '#6C63FF'
      }];
    } else {
      this.lineChartData = {
        labels: [],
        data: []
      };
      this.lineChartConfig.data.labels = [];
      this.lineChartConfig.data.datasets = [];
    }
    setTimeout(() => {
      this.isLineChartDataLoading = false;
    }, 300);
    this.cdr.detectChanges();
  }

  feedIdList: any = [];
  pagingDetails: any = {
    start: 0,
    end: 0,
    pageSize: 10,
    pageNumber: 1,
    total: 0,
    totalpages: 1
  }
  getUserFeeds() {
    this.isFeedsLoading = true;
    this.isLineChartDataLoading = true;
    this.feedIdList = [];
    this.pagingDetails = {
      start: 0,
      end: 0,
      pageSize: 10,
      pageNumber: 1,
      total: 0,
      totalpages: 1
    };
    let params: any = this.getQueryParams();
    params.size = 1000;
    params.page_number = 0;
    this._relationshipService.getUserFeedList(params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res: any) => {

      if (_.get(res, 'data.code') == 0 && _.has(res, 'data.feeds') && !_.isEmpty(res.data.feeds)) {
        this.lifetimeResponses = _.map(res.data.feeds, (obj: any) => {
          this.feedIdList.push(obj._id);
          obj.formated_created_date = moment(obj.created_date).format("DD MMM 'YY : h:mm")
          obj.created_date_timestamp = moment(obj.created_date).valueOf();
          obj.formated_feedback_request_date = moment(obj.feedback_request_date).format("DD MMM 'YY : h:mm")
          obj.feedback_request_date_timestamp = moment(obj.feedback_request_date).valueOf();
          obj.project_name = this.brandDetailsMap[obj?.brand_id]?.name || obj?.brand_id;
          obj.primary_rating = (_.isNull(obj?.feed_params?.primary_rating)) ? 'NA' : obj?.feed_params?.primary_rating;
          obj.journey_name = obj?.journeys?.join(', ') || 'NA';
          if (!obj?.feed_params?.comments) {
            obj.no_comment_provided = true;
            if (!obj?.feed_params) {
              obj.feed_params = {};
            }
            obj.feed_params.comments = 'No comment provided';
          }

          obj.comments = this.sanitizer.bypassSecurityTrustHtml(obj?.feed_params?.comments) || 'No comment provided';
          _.each(obj.journeys, (journeyName: any) => {
            // if (!this.lineChartDatastore.journeyNames.includes(journeyName)) {
            //   this.lineChartDatastore.journeyNames.push(journeyName)
            // }
            if (!this.lineChartDatastore.data[journeyName]) {
              this.lineChartDatastore.data[journeyName] = {
                labels: [],
                data: []
              }
            }
            if (obj.primary_rating !== undefined || obj.primary_rating !== null) {
              this.lineChartDatastore.data[journeyName].labels.push(moment(obj.created_date).format("DD MMM 'YY"));
              let rating: any = (obj.primary_rating !== undefined || obj.primary_rating !== null) ? obj.primary_rating : null;
              this.lineChartDatastore.data[journeyName].data.push(rating);
            }
          })

          return obj;
        })

      } else {
        this.lifetimeResponses = [];
      }

      this.lifeTimeResponsesCache = [...this.lifetimeResponses];
      _.each(this.journeyConfig.configs, (obj: any) => {
        if (this.lineChartDatastore.data[obj.name] && this.lineChartDatastore.data[obj.name].labels.length > 0) {
          this.lineChartDatastore.data[obj.name].labels = this.lineChartDatastore.data[obj.name].labels.reverse();
          this.lineChartDatastore.data[obj.name].data = this.lineChartDatastore.data[obj.name].data.reverse();
          this.viewTypeDropdown.options.push({ name: obj.name, field_id: obj.name })
          this.lineChartDatastore.journeyNames.push(obj.name)
        }
      })
      if (this.lineChartDatastore?.journeyNames && this.lineChartDatastore?.journeyNames?.length > 0) {
        // this.lineChartDatastore.journeyNames = this.lineChartDatastore.journeyNames.sort()
        this.activeJourney = this.lineChartDatastore.journeyNames[0]
        this.viewTypeDropdown.selectedOption = this.activeJourney
        this.updateLineChartData(this.lineChartDatastore.data[this.activeJourney])
      } else {
        this.activeJourney = null
      }
      // Apply sorting after loading data
      this.applySorting();
      this.isFeedsLoading = false;
      this.isLineChartDataLoading = false;
      this.cdr.detectChanges();
    }, (error) => {
      console.error('Error fetching user feeds:', error);
      this.lifetimeResponses = [];
      this.isFeedsLoading = false;
      this.isLineChartDataLoading = false;

      this.cdr.detectChanges();
    })
  }

  getQueryParams() {
    return {
      "account_id": this.accountId,
      "from": moment().subtract(2, 'year').format('YYYYMMDD'),
      "to": moment().format('YYYYMMDD'),
      "unique_field_id": this._relationshipService.unique_field_id,
      "unique_field_type": this._relationshipService.unique_field_type,
      "unique_field_value": this.customerDetail.user_id
    }

  }

  getNPS(total: number, promoters: number, detractors: number) {
    if (total > 0) {
      if (promoters === detractors) {
        return 0
      }
      return (((promoters / total) * 100) - ((detractors / total) * 100)).toFixed(0);
    }
    return "NA";
  }

  detractorBadgeColor: any = '#0B7139';
  passiveBadgeColor: any = '#FAB416';
  detractBadgeColor: any = '#EC2524';

  detractorBackgroundColor: any = '#EC252433';
  promoterBackgroundColor: any = '#0B713933';
  passiveBackgroundColor: any = '#FAB41633';

  // Sorting properties
  sortColumn: string = 'formated_created_date';
  sortDirection: 'asc' | 'desc' = 'desc';
  sortedLifetimeResponses: any = [];

  applyOpacity(color: string): string {
    if (color.startsWith('#')) {
      // Convert HEX to RGBA with 0.2 opacity
      let r = parseInt(color.substring(1, 3), 16);
      let g = parseInt(color.substring(3, 5), 16);
      let b = parseInt(color.substring(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, 0.2)`;
    }
    return color; // If it's already in rgba format, return as is
  }

  // Sorting methods
  sortTable(column: string) {
    if (this.sortColumn === column) {
      // If clicking the same column, toggle direction
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // If clicking a new column, set it as the sort column and default to asc
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.applySorting();
  }

  applySorting() {
    this.sortedLifetimeResponses = [...this.lifetimeResponses].sort((a, b) => {
      let column_key = this.sortColumn;
      if (column_key == 'formated_feedback_request_date') {
        column_key = 'feedback_request_date_timestamp';
      } else if (column_key == 'formated_created_date') {
        column_key = 'created_date_timestamp';
      }
      let aValue = this.getSortValue(a, column_key);
      let bValue = this.getSortValue(b, column_key);

      if (aValue === null || aValue === undefined) aValue = '';
      if (bValue === null || bValue === undefined) bValue = '';

      if (typeof aValue === 'string' && typeof bValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }

      if (aValue < bValue) {
        return this.sortDirection === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return this.sortDirection === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  getSortValue(item: any, column: string): any {
    switch (column) {
      case 'formated_feedback_request_date':
        return item.formated_feedback_request_date;
      case 'formated_created_date':
        return item.formated_created_date;
      case 'primary_rating':
        return item.primary_rating === 'NA' ? -1 : Number(item.primary_rating);
      case 'comments':
        return item.comments;
      case 'project_name':
        return item.project_name;
      case 'journey_name':
        return item.journey_name;
      default:
        return item[column];
    }
  }

  getSortIcon(column: string): string {
    if (this.sortColumn !== column) {
      return ''; // Default sort icon
    }
    return this.sortDirection === 'asc' ? '↑' : '↓';
  }

  isColumnSorted(column: string): boolean {
    return this.sortColumn === column;
  }


  openFeedDetails(feed: any) {
    this.pagingDetails.pageNumber = 1;
    this.pagingDetails.start = 0;
    this.pagingDetails.end = (this.feedIdList.length) ? this.feedIdList.length : 0;
    this.pagingDetails.total = (this.feedIdList.length) ? this.feedIdList.length : 0;
    this.pagingDetails.totalpages = 1;
    this.pagingDetails.pageSize = (this.feedIdList.length) ? this.feedIdList.length : 10;

    this._ltmsEvents.emit('feed-detail-panel', {
      feed_id: feed._id,
      feedIdList: (this.feedIdList.length) ? this.feedIdList : [],
      pagingDetails: this.pagingDetails
    });
  }

  onPageChange(event: any) {
    console.log('onPageChange', event);
  }
  changeTableFilter(filter: any) {
    
    if(this.activeTableFilter != filter){
      this.activeTableFilter = filter;
      this.lifetimeResponses = [...this.lifeTimeResponsesCache].filter((item: any) => {
        if (filter == 'promoter') {
          return item.primary_rating >= 9;
        } else if (filter == 'passive') {
          return item.primary_rating >= 7 && item.primary_rating <= 8;
        } else if (filter == 'detractor') {
          return item.primary_rating <= 6;
        }else{
          return false;
        }
      });
    }else{
      this.activeTableFilter = null;
      this.lifetimeResponses = [...this.lifeTimeResponsesCache];
    }
    
    this.applySorting();
    this.cdr.detectChanges();
  }
} 